import { LuBug, LuBuilding2, LuClipboardList, LuClock, LuCode, LuCpu, LuPalette, LuRocket, LuShoppingBag, LuSmartphone, LuUsers, LuWallet } from "react-icons/lu";

export const MobileAppHeroData = {
  backgroundImage: "/images/serviceBanners/MobileAppDevelopment.webp",
  whiteImage: "/images/serviceBanners/MobileAppDevelopmentW.webp",
  subTitle: "Custom Mobile App Development",
  title: (
    <>
      Delivering <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600">Future-Ready Mobile</span>
      <br /> Experiences
    </>
  ),
  description:
    "We build high-performance mobile applications designed to deliver seamless functionality, engaging user experiences, and scalable performance across Android and iOS platforms. Our mobile app development services help businesses improve customer engagement, streamline operations, and accelerate digital growth with modern mobile solutions tailored to evolving business needs.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Fast & Scalable Apps",
      desc: "Built for smooth performance, faster loading, and seamless mobile experiences.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Cross-Platform Compatibility",
      desc: "Optimized to perform across multiple devices and screen sizes.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Reliable App Architecture",
      desc: "Scalable mobile applications developed with modern technology standards.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "User-Centric Interface",
      desc: "Intuitive, clean, and engaging mobile app experiences for users.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "22%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const mobileAppAboutData = [
  {
    title: "Future-Ready Mobile Applications for Digital Growth",
    content: (
      <>
        Mobile applications have become an important part of modern business growth strategies. Businesses across industries invest in scalable digital solutions to improve
        customer engagement, increase accessibility, and strengthen their online presence. As an experienced{" "}
        <b className="text-text-primary font-semibold">mobile application development company</b>, businesses can build innovative mobile solutions that support long-term digital
        transformation and operational efficiency.
      </>
    ),
  },

  {
    title: "Custom Solutions for Modern Business Requirements",
    content: (
      <>
        Every business operates with unique goals and challenges, which is why <b className="text-text-primary font-semibold">custom mobile app development</b> plays a major role
        in creating personalized digital experiences. From startups to enterprises, organizations need applications that align with their workflows, customer expectations, and
        future scalability. Businesses looking for flexible Android solutions often collaborate with a trusted{" "}
        <a href="https://tychotechnologies.com/android-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          android app development company
        </a>{" "}
        to create applications that adapt to changing market demands.
      </>
    ),
  },

  {
    title: "Industry-Focused Mobile Development Services",
    content: (
      <>
        Mobile applications are widely used across industries including healthcare, education, retail, logistics, and finance. Apple users also expect premium mobile experiences
        with smooth functionality and strong security standards. Working with an experienced{" "}
        <a href="https://tychotechnologies.com/ios-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          ios app development company
        </a>{" "}
        helps businesses develop optimized applications for the Apple ecosystem while maintaining consistent usability and performance.
      </>
    ),
  },

  {
    title: "Scalable Mobile Development in India",
    content: (
      <>
        The demand for advanced <b className="text-text-primary font-semibold">android app development services</b> continues to increase as businesses focus on improving digital
        accessibility and customer interaction. Companies also prefer reliable <b className="text-text-primary font-semibold">app development services india</b> providers for
        experienced development teams and modern technologies. Choosing the right <b className="text-text-primary font-semibold">mobile app development company in india</b> helps
        businesses accelerate digital growth while ensuring scalable application development and long-term technical support.
      </>
    ),
  },
];

export const mobileDevelopSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Custom Mobile App Solutions for Every Business Need",
  buildCards: [
    {
      title: "Cross-Platform App Development",
      desc: "Build high-performance applications for Android and iOS using scalable cross-platform technologies.",
      icon: LuSmartphone,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Enterprise Mobile Solutions",
      desc: "Develop enterprise-grade mobile applications focused on scalability, security, and operational efficiency.",
      icon: LuBuilding2,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce App Development",
      desc: "Create feature-rich eCommerce applications with secure transactions and seamless shopping experiences.",
      icon: LuShoppingBag,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand App Solutions",
      desc: "Build modern booking, delivery, and service-based mobile applications with real-time functionality.",
      icon: LuClock,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FinTech App Development",
      desc: "Develop secure fintech applications with advanced features and modern user experiences.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Custom Mobile App Solutions",
      desc: "Tailored mobile applications developed according to your business goals and industry requirements.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Our Mobile App Development Process",
  processTitle: "Our Strategic Mobile App Development Approach",
  processSteps: [
    {
      step: "01",
      title: " Discovery & Consultation",
      description: "We understand your business objectives, target audience, and project requirements to create the right mobile strategy.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: " Strategy & Planning",
      description: "We define features, technology stack, and a clear roadmap for efficient project execution.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "We design modern, intuitive, and user-focused mobile interfaces that enhance engagement.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: " Mobile App Development",
      description: "We develop scalable and high-performance mobile applications with clean and maintainable architecture.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Quality Testing",
      description: "We test app functionality, security, and performance to ensure a seamless user experience.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "We launch your mobile application successfully and provide continuous maintenance and technical support.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "Why Choose Our Mobile App Development Services?",
  benefitsTitle: "Why Businesses Choose Mobile App Development Solutions",
  benefits: [
    "Cross-Platform Compatibility",
    "Faster App Development",
    "Modern User Interface",
    "Smooth App Performance",
    "Efficient Development Workflow",
    "Scalable Mobile Solutions",
    "Cost-Effective Development",
  ],
  logoImage: "/images/serviceBanners/MobileAppDevelopment.webp",
  whiteLogoImage: "/images/serviceBanners/MobileAppDevelopmentW.webp",
};

export const mobilePortfolioData = {
  subtitle: "OUR WORK",
  title: "Mobile Apps We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};
